// src/api/hooks/useElements.ts
import { useEffect, useState } from 'react';
import { ElementRead } from '../../api/apiTypes';
import { listElements } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export const useElements = (reportId?: string, componentId?: string) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [elements, setElements] = useState<ElementRead[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId || !componentId) return;

    const fetchElements = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await listElements(reportId, componentId);
        setElements(data);
      } catch (err) {
        console.error(err);
        setError('Errore nel caricamento degli elementi');
      } finally {
        setLoading(false);
      }
    };

    fetchElements();
  }, [reportId, componentId]);

  return { elements, loading, error };
};
